import { render, staticRenderFns } from "./chi-tiet-nhan-su.vue?vue&type=template&id=5b6c7a08"
import script from "./chi-tiet-nhan-su.vue?vue&type=script&lang=js"
export * from "./chi-tiet-nhan-su.vue?vue&type=script&lang=js"
import style0 from "./chi-tiet-nhan-su.vue?vue&type=style&index=0&id=5b6c7a08&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports